// 全站頭像、頭像框
import Image from 'next/image';
import { DEFAULT_HEAD } from '@/common/constant';

const UserAvatar = ({ avatar, avatarFrame, style }) => {
    if (avatar)
        return (
            <div className={`img-box aspect-[1] !overflow-visible flex-shrink-0 ${style}`}>
                {/* 頭像 */}
                <Image
                    className={`rounded-[50%]  ${
                        avatarFrame ? '!w-[95%] set-center !h-[95%]' : ''
                    }`}
                    width={70}
                    height={70}
                    src={avatar || DEFAULT_HEAD}
                    alt="avatar"
                />

                {avatarFrame && (
                    <Image
                        className="absolute !w-[120%] !h-[120%] set-center !max-w-[unset] !z-[2] !object-contain"
                        width={34}
                        height={34}
                        src={avatarFrame}
                        alt="frame"
                        sizes="30px"
                    />
                )}
            </div>
        );

    return <></>;
};

export default UserAvatar;
